import { render, staticRenderFns } from "./OrderDetailCustomer.vue?vue&type=template&id=f16c3d74"
import script from "./OrderDetailCustomer.vue?vue&type=script&lang=js"
export * from "./OrderDetailCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports